import React from "react";
import { Col, FormGroup, Label, CustomInput, UncontrolledTooltip } from "reactstrap";

const ReleaseStoreCheckboxItem = ({ store, checked, onChange, disabled }) => (
  <Col xs="12" sm="6" md="4" lg="3">
    <FormGroup check style={{ margin: "0 0 10px 0" }}>
      <Label check>
        <CustomInput
          type="checkbox"
          id={`store_${store.checkboxId || store.id}`}
          checked={checked}
          disabled={disabled}
          onChange={(e) => onChange(e.target.checked, store)}
        />{" "}
        <span
          id={`store_label_${store.checkboxId || store.id}`}
          style={store.disabledReason ? { color: "#6c757d", cursor: "help" } : undefined}
        >
          {store.checkboxLabel || store.display_name || store.name}
        </span>
        {store.disabledReason && (
          <UncontrolledTooltip target={`store_label_${store.checkboxId || store.id}`}>
            {store.disabledReason}
          </UncontrolledTooltip>
        )}
      </Label>
    </FormGroup>
  </Col>
);

export default ReleaseStoreCheckboxItem;
